export enum LogRecordStatus {
  Driving = 'driving',

  OffDuty = 'off-duty',
  PersonalConveyance = 'personal-conveyance',

  SleeperBerth = 'sleeper-berth',

  OnDuty = 'on-duty',
  YardMove = 'yard-move',

  IntermediateConventional = 'intermediate-conventional',
  IntermediateReduced = 'intermediate-reduced',

  Certification = 'certification',

  Login = 'login',
  Logout = 'logout',

  PowerOnConventional = 'power-on-conventional',
  PowerOnReduced = 'power-on-reduced',
  PowerOffConventional = 'power-off-conventional',
  PowerOffReduced = 'power-off-reduced',

  MalfunctionLogged = 'malfunction-logged',
  MalfunctionCleared = 'malfunction-cleared',
  DiagnosticLogged = 'diagnostic-logged',
  DiagnosticCleared = 'diagnostic-cleared',
}
